import { DirectiveType } from '../../types';
import { AbstractMultiValueDirective } from '../abstract-multi-value-directive';
export class FrameSource extends AbstractMultiValueDirective {
    getDirectiveName() {
        return 'frame-src';
    }
    getDirectiveType() {
        return DirectiveType.Fetch;
    }
}
